<template>
    <!-- Header
    ============================================= -->
    <header id="header" class="sticky-style-2 mb-2">

        <div class="container clearfix">

            <!-- Logo
            ============================================= -->
            <div id="logo">
                <a href="https://www.tdadental.com/" class="standard-logo">
                    <img src="../../assets/logo.png" alt="TDA Logo">
                </a>
                <a href="https://www.tdadental.com/" class="retina-logo">
                    <img src="../../assets/logo.png" alt="TDA Logo">
                </a>
            </div><!-- #logo end -->

            <ul class="header-extras">
                <li>
                    <i class="i-plain icon-call nomargin" style="cursor: auto; color: #444"></i>
                    <div class="he-text">
                        Call Us
                        <span>888-422-1995</span>
                    </div>
                </li>
                <li>
                    <a href="https://www.tdadental.com/about/contact">
                        <i class="i-plain icon-line2-envelope nomargin"></i>
                        <div class="he-text">
                            Contact Us
                            <span>We're here to help</span>
                        </div>
                    </a>
                </li>
            </ul>

        </div>

        <div id="header-wrap">
            <main-menu v-if="!isLogin"></main-menu>
        </div>

    </header><!-- #header end -->
</template>

<script>
    import MainMenu from '@/components/Header/MainMenu'

    export default {
        name: 'TopHeader',
        components: {MainMenu},
        computed: {
            isLogin () {
                return this.$route.path === '/'
            }
        }
    }
</script>

<style scoped>

</style>
